import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import DashboardComponents from '../components/DashboardComponents';
import Loading from '../components/Loading';
import NavBar from '../../components/NavBar';

const ResellerDashboard = () => {
  const [loading, setLoading] = useState(true); 

  return (
    <div>
      <Helmet>
        <title>Reseller | {process.env.REACT_APP_SITE_NAME}</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      {loading && (
          <Loading />
        )
      }
      <div>
        <NavBar />
        <DashboardComponents setLoading={setLoading} />
      </div>
    </div>
  );
};

export default ResellerDashboard;
